import { node } from "~/util/dom";
import { IRibbonItemPOIData } from "./interfaces";
import { WIDTH_POI } from "./const";

interface IRibbonItemPOI extends IRibbonItemPOIData {
	width?: number;
	onClick?: () => void;
}

export default class RibbonItemPOI {
	_data: IRibbonItemPOI;

	_dom: {
		container: HTMLAnchorElement;
	};

	constructor(data: IRibbonItemPOI) {
		this._data = {
			width: WIDTH_POI,
			onClick: () => {},
			...data,
		};

		this._build();
	}

	get container() {
		return this._dom.container;
	}

	get width() {
		return this._data.width;
	}

	get data() {
		return this._data;
	}

	_build() {
		const container = node("a", { className: "ribbonItemPOI", href: this._data.link });
		const header = node("div", { className: "ribbonItemPOI__header" });
		const headerInner = node("div", { className: "ribbonItemPOI__headerInner" });
		const bottom = node("div", { className: "ribbonItemPOI__bottom" });
		const headerPoi = node("div", { className: "ribbonItemPOI__headerPOI" });
		const headerReview = node("div", { className: "ribbonItemPOI__headerReview" });
		const poiIcon = node("div", { className: "ribbonItemPOI__poiIcon" });
		const poiTitles = node("div", { className: "ribbonItemPOI__poiTitles" });
		const poiTitle = node("p", { className: "ribbonItemPOI__poiTitle" });
		const poiSubtitle = node("p", { className: "ribbonItemPOI__poiSubtitle" });
		const headerReviewBadge = node("div", { className: "ribbonItemPOI__headerBadge" });
		const headerReviewComposed = node("div", { className: "ribbonItemPOI__headerComposed" });
		const headerReviewComposedText = node("span", { className: "ribbonItemPOI__headerComposedText" });
		const headerReviewComposedReviews = node("span", { className: "ribbonItemPOI__headerComposedReviews" });
		const userReviewLine = node("div", { className: "ribbonItemPOI__userReviewLine" });
		const userAvatar = node("div", { className: "ribbonItemPOI__userAvatar" });
		const starsCont = node("div", { className: "ribbonItemPOI__starsCont" });
		const desc = node("p", { className: "ribbonItemPOI__desc clamp-lines-3" });
		const date = node("p", { className: "ribbonItemPOI__date" });

		if (this._data.poiBadge === "green" || this._data.poiBadge === "gray") {
			const badgeNew = node("mapy-review-badge-new");

			badgeNew.rating = this._data.poiRating;
			badgeNew.top = this._data.poiBadge === "green";
			badgeNew.size = "small";
			headerReviewComposed.append(badgeNew);
		}

		if (this._data.poiImage) {
			const bgImage = node("img", { className: "ribbonItemPOI__headerImage" });
			const bgCover = node("div", { className: "ribbonItemPOI__headerImageCover" });

			bgImage.src = this._data.poiImage;
			header.classList.add("has-image");
			header.append(bgImage, bgCover);
		}

		if (this._data.avatar) {
			const userAvatarImage = node("img", { className: "ribbonItemPOI__userAvatarImage" });

			userAvatarImage.src = this._data.avatar;
			userAvatar.append(userAvatarImage);
		}

		if (this._data.poiIcon) {
			const poiIconImage = node("img", { className: "ribbonItemPOI__poiIconImage" });

			poiIconImage.src = this._data.poiIcon;
			poiIcon.appendChild(poiIconImage);
		}

		const starsBanner = node("mapy-review-stars");

		starsBanner.disabled = true;
		starsBanner.setAttribute("size", "16");
		starsBanner.setAttribute("gap", "2");
		/* eslint-disable-next-line */
		starsBanner.setAttribute("value", ((this._data.reviewRating / 100) * 5).toString());
		starsCont.append(starsBanner);

		container.style.width = `${this._data.width}px`;
		desc.textContent = this._data.reviewText;
		date.textContent = this._data.reviewDate;
		userReviewLine.append(userAvatar, starsCont, date);
		headerReviewComposedText.textContent = this._data.poiRatingText;
		headerReviewComposedReviews.textContent = `(${this._data.poiReviewsCount})`;
		poiTitle.textContent = this._data.poiTitle;
		poiSubtitle.textContent = this._data.poiSubtitle;
		headerPoi.append(poiIcon, poiTitles);
		headerReviewComposed.append(headerReviewComposedText, headerReviewComposedReviews);
		headerReview.append(headerReviewBadge, headerReviewComposed);
		poiTitles.append(poiTitle, poiSubtitle);
		header.append(headerInner);
		headerInner.append(headerPoi, headerReview);
		bottom.append(userReviewLine, desc);
		container.append(header, bottom);

		this._dom = {
			container,
		};

		container.addEventListener("click", event => {
			event.stopPropagation();
			event.preventDefault();
			this._data.onClick();
		});
	}
}
